import { Column, ColumnStore, DateHelper } from "@bryntum/schedulerpro";
import {defaultGroupRenderer} from "../../other/utils/utils.jsx";

export default class AgingColumn extends Column {
  static get $name() {
    return "AgingColumn";
  }

  static get type() {
    return "agingColumn";
  }

  static get fields() {
    return ["barMargin"];
  }

  static get defaults() {
    return {
      barMargin: 10,
      filterable: false,
      sortable(a, b) {
        if (a[this.field] === b[this.field]) {
          return new Date(a.createdAt) - new Date(b.createdAt);
        } else {
          return a[this.field] - b[this.field];
        }
      }
    };
  }

  renderer({ value }) {
    return DateHelper.formatCount(value, 'day');
  }

  groupRenderer(e) {
    return defaultGroupRenderer({ ...e, groupRowFor: DateHelper.formatCount(e.groupRowFor, 'day') });
  }
}

ColumnStore.registerColumnType(AgingColumn);
